import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

const EditCategoryModal = ({ isOpen, category, onClose, onUpdate }) => {
    if (!isOpen) return null; // Don't render the modal if it's not open

    const [editCategory, setEditCategory] = useState(category);

    useEffect(() => {
        setEditCategory(category);
    }, [category]);

    const handleSave = () => {
        if (!editCategory.categoryName) {
            alert("Category name is required.");
            return;
        }
        onUpdate(editCategory);
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Edit Category</h3>
                    <button className="close-button" onClick={onClose}>
                        ✕
                    </button>
                </div>

                <div className="modal-body">
                    <div className="form-group">
                        <label>Category Name</label>
                        <input
                            type="text"
                            className="filterInput"
                            value={editCategory.categoryName || ""}
                            onChange={(e) =>
                                setEditCategory({
                                    ...editCategory,
                                    categoryName: e.target.value,
                                })
                            }
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Display?</label>
                        <input
                            type="checkbox"
                            checked={editCategory.display || false}
                            onChange={(e) =>
                                setEditCategory({
                                    ...editCategory,
                                    display: e.target.checked,
                                })
                            }
                        />
                    </div>

                    <div className="modal-actions">
                        <button className="baseButton" onClick={handleSave}>
                            Save Changes
                        </button>
                        <button className="baseButton secondary" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body // Renders the modal outside the regular DOM hierarchy
    );
};

export default EditCategoryModal;
